var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaptopZash = function SvgLaptopZash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laptop_zash_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15v25h35V15h-35Zm-5-2.482C7.5 11.127 8.637 10 9.98 10h40.04c1.37 0 2.48 1.123 2.48 2.518V45h-45V12.517ZM0 47.5h60v5H0v-5Z",
    fill: "#1D1737"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "laptop_zash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v60H0z"
  })))));
};
export default SvgLaptopZash;